import React, { useState } from 'react'
import classNames from 'classnames'
import { type ITextFieldPlaceholderProps, TextFieldPlaceholder } from 'shared/ui/TextField'
import { Chip } from 'shared/ui/Chip/Chip'
import styles from './styles.module.scss'

type IMultiTextFieldProps = {
  values: string[]
  onDelete: (value: string) => void
  onCreate: (value: string) => void
} & Omit<ITextFieldPlaceholderProps, 'placeholder'>

export const MultiTextField = ({ values, onDelete, onCreate, ...props }: IMultiTextFieldProps) => {
  const [value, setValue] = useState('')

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && value) {
      onCreate(value)
      setValue('')
    }
  }

  const onBlur = () => {
    if (value) {
      onCreate(value)
    }
    setValue('')
  }

  return (
    <TextFieldPlaceholder
      multiline
      variant='stroke'
      size='medium'
      className={classNames(styles.wrap, { [styles.witchValues]: !!values.length })}
      placeholder={
        <div className={styles.multiList}>
          <div className={styles.placeholderWrap}>
            {values?.map((item) => (
              <Chip
                key={item}
                item={{
                  id: item,
                  label: item,
                }}
                label={item}
                iconType='div'
                onDelete={() => onDelete?.(item)}
              />
            ))}
            <input
              type='text'
              className={styles.searchInput}
              placeholder='Enter value and press enter'
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={onKeyDown}
              onBlur={onBlur}
            />
          </div>
        </div>
      }
      {...props}
    />
  )
}
